// extracted by mini-css-extract-plugin
export default {"success-message":"SuccessMessage_success-message__U2e4z"};